import { defineNuxtRouteMiddleware } from '#imports'
import { asRouteMiddleware, requireAuth } from '@router/route-guards'

export default defineNuxtRouteMiddleware(asRouteMiddleware(requireAuth))
